export const APP_DEFAULT_ADULTS = 2;
export const APP_DEFAULT_CHILDREN = 0;
